import React, { useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// import get from 'lodash/get';
import moment from 'moment';
import * as StatsModule from 'modules/stats';
// import * as SystemModule from 'modules/system';

// import CategoryStats from 'components/CategoryStats';
// import GraphStats from 'components/GraphStats';

import classes from '../LandingPage.module.scss';
import QueryString from 'qs';
import { CircleProcess } from 'components/CircleProcess';
import Filters from 'pages/Statistics/Filters';
import { StatCard } from 'features/stat-by-document/components/stat-card';

const Stats: React.FC = () => {
  const { t } = useTranslation();
  // const history = useHistory();
  const location = useLocation()
  // const { language } = SystemModule.Hooks.useLanguage();
  const { filter = {} } = QueryString.parse(location.search, { ignoreQueryPrefix: true }) as any
  const date = filter?.date ? moment(filter.date).format('MM/YYYY') : undefined;


  const { statuses } = StatsModule.Hooks.useList({
    date
  });

  // const graphItems = days.map(item => {
  //   return {
  //     title: `${item.day}`,
  //     date: moment.unix(item.date).format('DD MMMM YYYY'),
  //     count: {
  //       all: item.statuses.all,
  //       processing: item.statuses.in_review,
  //       rejected: item.statuses.denied,
  //       approved: item.statuses.completed
  //     }
  //   };
  // });

  const calculatePercentage = useCallback((total, num) => {
    if (total) {
      return +((num / total) * 100).toFixed(2)
    }
    return 0
  }, [])

  return (
    <div className={classes.section}>
      <div className={classes.sectionHeader}>
        <div className={classes.continer}>
          <div className={classes.sectionTitle}>
            {t('General_statistics')}
          </div>
          <Link className={classes.sectionLink} to="/statistics">
            {t('Detailed_statistics')}
          </Link>
        </div>
        <Filters />
      </div>
      <div className={classes.sectionContent}>
        <div className={classes.quickStatsList}>
          <div className={classes.quickStatsListInner}>
            <div className={classes.quickStatsItem}>
              <CircleProcess status='ALL' color="#29CC39" title={statuses.all} description={t('Received_applications')} percent={statuses.all > 0 ? 99 : 0} />
            </div>
            <div className={classes.quickStatsItem}>
              <CircleProcess status='IN_REVIEW' color="#FF6633" title={statuses.in_review} description={t('Applications_under_review')} percent={calculatePercentage(statuses.all, statuses.in_review)} />
            </div>
            <div className={classes.quickStatsItem}>
              <CircleProcess status='DENIED' color="#E62E2E" title={statuses.denied} description={t('Rejected_applications')} percent={calculatePercentage(statuses.all, statuses.denied)} />
            </div>
            <div className={classes.quickStatsItem}>
              <CircleProcess status='COMPLETED' color="#34CEFF" title={statuses.completed} description={t('Completed_applications')} percent={calculatePercentage(statuses.all, statuses.completed)} />
            </div>
            <div className={classes.quickStatsItem}>
              <CircleProcess status='EXPIRED' color="#E62E7B" title={statuses.auto_completed} description={t('Auto_completed')} percent={calculatePercentage(statuses.all, statuses.auto_completed)} />
            </div>
          </div>
        </div>
        <div className={classes.categoryStats}>
            <div className={classes.categoryStatsTitle}>{t('By_category')}</div>
            <div className={classes.categoryStatsList}>
              <StatCard params={{ date }} />
              {/* {categories.slice(0, 6).map((item, index) => (
                <div key={index} className={classes.categoryStatsListItem}>
                  <CategoryStats
                    title={get(item, `category.title[${language}]`)}
                    image={item.category.icon}
                    amount={t('application_amount', { count: item.count })}
                    percent={item.percent}
                    onClick={() => history.push(`/registry?filter[category_id]=${item.category.id}`)}
                  />
                </div>
              ))} */}
            </div>
          </div>
        {/* <div className={classes.graphCategoryStats}>
          {!!days.length && (
            <div className={classes.graphStats}>
              <GraphStats
                title={t('Statistics_month')}
                date={`${moment.unix(get(days, '[0].date')).format('DD.MM.YYYY')} - ${moment.unix(get(days, `[${days.length - 1}].date`)).format('DD.MM.YYYY')}`}
                items={graphItems}
              />
            </div>
          )}
          
        </div> */}
      </div>
      {!window.matchMedia('(min-width: 992px)').matches && (
        <div className={classes.sectionHeader}>
          <Link className={classes.sectionLink} to="/statistics">
            {t('Detailed_statistics')}
          </Link>
        </div>
      )}
    </div>
  );
};

export default Stats;
